import { createFeatureSelector, createSelector } from '@ngrx/store';
import { AuthState } from "./auth.reducer";

export const selectFeature = createFeatureSelector<AuthState>('Auth');

export const AuthSelector = {
	selectRequestProcessing: createSelector(
		selectFeature,
		(state) => {
			return state.requestProcessing;
		}
	),
	selectCustomerDoRegister: createSelector(
		selectFeature,
		(state) => {
			return state.CustomerDoRegister;
		}
	),
	selectCustomerDoRegisterFailure: createSelector(
		selectFeature,
		(state) => {
			return state.CustomerDoRegister;
		}
	),

	selectWishlistItemsCriteria: createSelector(
		selectFeature,
		(state) => {
			return state.WishlistItems.criteria;
		}
	),
	selectWishlistItemsResponse: createSelector(
		selectFeature,
		(state) => {
			return state.WishlistItems.response;
		}
	),

	selectShippingAddress: createSelector(
		selectFeature,
		(state) => {
			return state.ShippingAddress.response;
		}
	),

	SelectAddItemToWishlist: createSelector(
		selectFeature,
		(state) => {
			return state.AddItemToWishlist.response;
		}
	),

	SelectDeleteItemToWishlist: createSelector(
		selectFeature,
		(state) => {
			return state.DeleteItemToWishlist.response;
		}
	),

	SelectResendOtpResponse: createSelector(
		selectFeature,
		(state) => {
			return state.ResendOtp.response;
		}
	),

	SelectGetCityAndStateFromZipcodeResponse: createSelector(
		selectFeature,
		(state) => {
			return state.GetCityAndStateFromZipcode.response;
		}
	),

};
